// extracted by mini-css-extract-plugin
module.exports = {"global-freight-summit-2023":"GlobalFreightSummit2023_global-freight-summit-2023__jF5ar"};